import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyApm4ESJY3gdTqR6WO-wCUp-cHq83rcK7Y",
  authDomain: "myownbill-c16d8.firebaseapp.com",
  projectId: "myownbill-c16d8",
  storageBucket: "myownbill-c16d8.firebasestorage.app",
  messagingSenderId: "376448402343",
  appId: "1:376448402343:web:b0844ac4d9d0dce043ec82",
  measurementId: "G-7XTMJREN08"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);